/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PersonWithZugaengeDto } from '../../models/person-with-zugaenge-dto';

export interface GetAllPersonenWithZugaenge$Json$Params {
}

export function getAllPersonenWithZugaenge$Json(http: HttpClient, rootUrl: string, params?: GetAllPersonenWithZugaenge$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PersonWithZugaengeDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllPersonenWithZugaenge$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PersonWithZugaengeDto>>;
    })
  );
}

getAllPersonenWithZugaenge$Json.PATH = '/v1/personzugaenge';
